const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment-timezone');

/**
 * Defines the dynamic messaging component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('assignmentDynamicMessage', ['Application', 'Authorization', 'DynamicMessages', 'CompanyIntegrations', '$translate', '$sce', 'escapeHtml',  function (Application, Authorization, DynamicMessages, CompanyIntegrations, $translate, $sce, escapeHtml) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      messageId: '=',
      values: '=',
      show: '=',
      addMessage: '&',
      content: '=',
      editOnly: '=?',
      disableAssignmentOverdue: '<',
    },
    template: require('../../../templates/directives/assignments/assignment-dynamic-message.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user = Authorization.getAuthToken().user;
      self.slackAvailable = false;
      self.contentType = 'assignment';

      $scope.trustedHtml = function (plainText) {
        return $sce.trustAsHtml(plainText);
      };

      CompanyIntegrations.status({}, function (data) {
        var companyIntegration = data || {};
        self.slackAvailable = companyIntegration.slack || false;
      }, function (error) {
        console.log('Error occured getting company integration ', error);
      });

      self.check = function() {
        if (!self.content.name) {
          $translate(['assignmentDynamicMessage.name_is_required']).then(function (translations) {
            Application.messaging.addMessage({
              type: 'error',
              duration: 5,
              text: translations['assignmentDynamicMessage.name_is_required'],
            });
          });
          self.info.saving = false;
          return false;
        }
        if (!self.content.channels || !self.content.channels.length) {
          $translate(['assignmentDynamicMessage.at_least_one_channel']).then(function (
            translations
          ) {
            Application.messaging.addMessage({
              type: 'error',
              duration: 5,
              text: translations['assignmentDynamicMessage.at_least_one_channel'],
            });
          });
          self.info.saving = false;
          return false;
        }
        for (var i = 0; i < self.content.channels.length; i++) {
          if (
            !self.content.messaging ||
            !self.content.messaging[self.content.channels[i]] ||
            !self.content.messaging[self.content.channels[i]].length
          ) {
            $translate(['assignmentDynamicMessage.please_include_messaging']).then(function (
              translations
            ) {
              Application.messaging.addMessage({
                type: 'error',
                duration: 5,
                text: translations['assignmentDynamicMessage.please_include_messaging'],
              });
            });
            self.info.saving = false;
            return false;
          }
        }
        if (self.content.type === 'assignment_overdue' && !self.content.overdueCadence) {
          $translate(['assignmentDynamicMessage.please_include_overdue_frequency']).then(function (
            translations
          ) {
            Application.messaging.addMessage({
              type: 'error',
              duration: 5,
              text: translations['assignmentDynamicMessage.please_include_overdue_frequency'],
            });
          });
          self.info.saving = false;
          return false;
        }
        return true;
      };

      self.info = {
        newMessage: true,
        loading: false,
        saving: false,
        editConfirmation: false,
        default: {
          name: '',
          content_type: 'Assignment',
          type: 'assignment_created',
          recipient: 'assignee',
          channels: ['in_app', 'slack', 'email'],
          messaging: {
            in_app: [],
            slack: [{ name: 'include_template', value: 'active' }],
            email: [],
          },
          options: [],
          scheduled: false,
          overdueCadence: null,
          overdueOccurrences: 1,
        },
        activeTab: 'schedule',
        cancel: function () {
          $scope.messageId = false;
          $scope.show = false;
        },
        save: function () {
          if (!$scope.editOnly) {
            self.info.update();
            return;
          }
          self.info.editConfirmation = true;
        },
        update: function () {
          self.info.saving = true;
          if (!self.check()) {
            return;
          }
          var body = Object.assign(self.content, {
            type: `${self.content.type}_${self.content.recipient}`,
          });
          DynamicMessages.update(
            {
              subresource: self.content._id,
              fields:
                'company,user,scheduled,type,content_id,content_type,channels,messaging,scheduled_duration,options,name',
            },
            body
          )
            .$promise.then(function (message) {
              self.info.loading = true;
              if (self.content.time_before_due) {
                message.time_before_due = self.content.time_before_due;
              }
              if (self.content.type === 'assignment_overdue_assignee') {
                message.cadence = self.content.overdueCadence;
                message.total_messages = self.content.overdueOccurrences;
              }
              $scope.addMessage({ message: message });
              self.info.saving = false;
              self.info.editConfirmation = true;
            })
            .catch(function (error) {
              console.log('error: ', error);
              self.info.saving = false;
            });
        },
        create: function () {
          self.info.saving = true;
          if (!self.check()) {
            return;
          }
          self.content.user = self.user._id;
          if (!self.slackAvailable) {
            for (var i = self.content.channels.length - 1; i > 0; i--) {
              if (self.content.channels[i] === 'slack') {
                self.content.channels.splice(i, 1);
              }
            }
          }
          var body = Object.assign(self.content, {
            type: `${self.content.type}_${self.content.recipient}`,
          });

          DynamicMessages.create(body)
            .$promise.then(function (message) {
              self.info.loading = true;
              if (self.content.time_before_due) {
                message.time_before_due = self.content.time_before_due;
              }
              if (self.content.type === 'assignment_overdue_assignee') {
                message.cadence = self.content.overdueCadence;
                message.total_messages = self.content.overdueOccurrences;
              }
              $scope.addMessage({ message: message });
              self.info.saving = false;
            })
            .catch(function (error) {
              console.log('error: ', error);
            });
        },
      };

      var makeContentList = function() {
        if (!$scope.content || !$scope.content.length) {
          return '<ul><li><a href="">Leadership 101 [Example]</a></li></ul>';
        }
        var list = '<ul>';
        $scope.content.forEach(function(item) {
          // The email preview is trusted HTML, and titles are stored as plain text.
          list += '<li><a href="">' + escapeHtml(item.title || item.name) + '</a></li>';
        });
        list += '</ul>';
        return list;
      };

      self.preview = {
        locationToggle: false,
        getBody: function(content) {
          var body = '';
          var opts = ['email', 'slack', 'in_app'];
          if (opts.indexOf(content) === -1 || !self.content || !self.content.messaging) {
            return body;
          }
          if (self.content.messaging[content] && self.content.messaging[content].length) {
            self.content.messaging[content].forEach(function(item) {
              if (item.name === 'body') {
                body = self.preview.parseTemplate(item.value, content);
              }
            });
          }

          return body;
        },
        escapeRegExp: function (str) {
          return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        },
        templateReplace: function (str, find, replace) {
          return str.replace(new RegExp(self.preview.escapeRegExp(find), 'g'), function() { return replace; });
        },
        parseTemplate: function (template, content) {
          var variables = {};
          var stack = [];
          var newString = template.slice(0);
          var options = Object.assign({}, self.preview.options);
          if (content !== 'email') {
            delete options.assigned_content;
          }

          for(var i = 0; i < template.length; i++) {
            if (template[i] === '{') {
              stack.push(i);
            }
            if (template[i] === '}' && stack.length) {
              variables[template.substring(stack.pop() + 1, i)] = true;
            }
          }

          for (var key in variables) {
            if (options[key]) {
              newString = self.preview.templateReplace(newString, '{' + key + '}', options[key]);
              continue;
            }
          }

          return newString;
        },
        options: {
          due_in: '3',
          days_overdue: 'X', 
          assigner_first_name: 'Jane',
          assigner_last_name: 'Doe',
          assignee_first_name: 'Joe',
          assignee_last_name: 'Williams',
          recipient_first_name: 'John',
          recipient_last_name: 'Smith',
          assigned_content: makeContentList()
        },
        slackIncludeTemplate: function() {
          if (!self.content || !self.content.messaging || !self.content.messaging.slack || !self.content.messaging.slack.length) {
            return false;
          }
          for (var i = 0; i < self.content.messaging.slack.length; i++) {
            if (self.content.messaging.slack[i].name === 'include_template' && self.content.messaging.slack[i].value === 'active') {
              return true;
            }
          }
          return false;
        }
      };

      self.hasChannel = function(name) {
        if (!self.content || !self.content.channels) {
          return false;
        }
        return self.content.channels.indexOf(name) !== -1;
      };

      self.initialize = function() {
        self.info.loading = true;
        if ($scope.messageId) {
          DynamicMessages.get({subresource: $scope.messageId, fields: 'company,user,scheduled,type,content_id,content_type,channels,messaging,scheduled_duration,options,name'}).$promise
          .then(function(message) {
            self.content = Object.assign({}, message);
            if ($scope.values && $scope.values.reminder_messages && $scope.values.reminder_messages.length) {
              $scope.values.reminder_messages.forEach(function(item) {
                if (item.message === self.content._id) {
                  self.content.time_before_due = item.time_before_due;
                }
              });
            }
            if ($scope.values && $scope.values.overdue_messages && $scope.values.overdue_messages.length) {
              $scope.values.overdue_messages.forEach(function(item) {
                if (item.message === self.content._id) {
                  self.content.overdueCadence = item.cadence;
                  self.content.overdueOccurrences = item.total_messages;
                }
              });
            }
            var splitType = self.content.type.split('_');
            self.content.type = splitType[0] + '_' + splitType[1];
            self.content.recipient = splitType[2];
            self.info.loading = false;  
            self.newMessage = false;
          });
          return;
        }
        self.content = Object.assign({}, self.info.default);

        self.info.loading = false;
      };

      self.initialize();

      self.getImage = function(item) {
        var image = item.images || item.image || item.banner_image;

        if (image === null || image === undefined) {
          return 'https://d2277n3gvptnup.cloudfront.net/images/51d5f21b2f410a020b000002/43100c70-9d98-4b08-bb4f-8bdd70547f5f.jpeg';
        }
        if (item.type === 'scorm' && (item.image || item.banner_image)) {
          return item.image || item.banner_image;
        }
        if (typeof image === 'string' && image !== "") {
          return image;
        }
        if (typeof image === 'object' && image.medium) {
          return image.medium;
        }
        if (typeof image === 'object' && image.explore) {
          return image.explore;
        }
        if (typeof image === 'object' && image.custom) {
          return image.custom;
        }

        return 'https://d2277n3gvptnup.cloudfront.net/images/51d5f21b2f410a020b000002/43100c70-9d98-4b08-bb4f-8bdd70547f5f.jpeg';
      };

      $scope.$watch('show', function(newVal, oldVal) {
        if (newVal) {
          self.content = null;
          self.initialize();
        }
      });

    }],
    controllerAs: 'dynamic'
  }
}])